import Server from 'src/new/server/Server';
import SourceTextCache from 'src/new/sources/SourceTextCache';

interface Verse {
    index: number;
    versions: SourceText[];
}

interface SourceText {
    versionIndex: number;
    text: string;
}

export default class SourceTextCacher {

    public static async cacheVerses(startVerseIndex: number, endVerseIndex: number, cache: SourceTextCache): Promise<void> {
        const path = `verse-versions/verses/${startVerseIndex}/${endVerseIndex}`;
        const verses = await Server.newRequest().get<Verse[]>(path);
        verses.forEach((verse) => {
            const text = new Map(verse.versions.map<[number, string]>((version) => [version.versionIndex, version.text]));
            cache.putVerse(verse.index, text);
        });
    }
}
